import React from 'react'
import { Row, Col, Typography, Divider } from 'antd'
import { HeaderHero, SEO } from './components'

import WhyCureStyle from '../../styles/WhyCure.module.css'
import GetQuoteAndCustomerLinks from './GetQuoteAndCustomerLinks/GetQuoteAndCustomerLinks.js'

const tabletImage = 'hero/why-cure/Why-Cure_1024x300-no-copy.jpg'
const desktopImage = 'hero/why-cure/Why-Cure_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/why-cure/Why-Cure_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/why-cure/Why-Cure_1960x300-no-copy.jpg'
const smallImage = 'hero/why-cure/Why-Cure_375x188.jpg'
const smallImage390 = 'hero/why-cure/Why-Cure_390x188.jpg'
const mobileImage = 'hero/why-cure/Why-Cure_428x188.jpg'
const mobileImage768 = 'hero/why-cure/Why-Cure_768x300-no-copy.jpg'

const { Link, Text, Title } = Typography

const WhyCure = () => {

  return (
    <>
      <SEO
        description="CURE's not-for-profit model focuses on your driving record, not discriminatory factors like education or occupation."
        title="CURE's Unique Model for Affordable Car Insurance | CURE"
        url="/why-cure"
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        title="WHY CURE"
        xtraLargeScreenImage={xtraLargeScreenImage}
        alt={"Why CURE auto insurance affordable"}
      />
      <div className={`${WhyCureStyle["why-cure-screen"]} page-text-margin`}>
        <Row className={`${WhyCureStyle["margin-bottom-12"]} ${WhyCureStyle["padding-0"]}`}>
          <Text className={`${WhyCureStyle["why-cure-text-below-title"]}`}>At CURE, we don’t need reform to do what’s right.</Text>
        </Row>
        <Row>
          <Text className={`${WhyCureStyle["why-cure-subtitle"]}`}>Standing up for common sense</Text>
          <Text className={`${WhyCureStyle["why-cure-text"]}`}>
            We believe that everyone deserves car insurance at a fair rate that is based primarily on their driving
            record. We strive to not only fulfill this mission, but also to educate the public in the process. Our
            not-for-profit model allows CURE to continually offer affordable car insurance to responsible drivers.
          </Text>
          <Text className={`${WhyCureStyle["why-cure-subtitle"]}`}>The voice of reason</Text>
          <Text className={`${WhyCureStyle["why-cure-text"]}`}>
            CURE is the voice of reason for responsible drivers who have been discriminated against by other 
            companies based on factors that shouldn't impact car insurance rates. This includes income proxies 
            such as education and occupation. Instead, we lead the way in transforming the car insurance industry 
            to remove income discriminating practices.
          </Text>
        </Row>
        <div>
          <div className={`${WhyCureStyle["side-text"]}`}>
            <Link href="https://unjustcarinsurance.com" rel="noreferrer" target="_blank">
              <Col className="text-center">
                <Title className={`${WhyCureStyle["head-title"]}`} level={2}>
                  New Jersey Drivers
                </Title>
              </Col>
              <Col className={`${WhyCureStyle["head-title-sub-text"]}`}>
                <Text>
                  Join CURE in our crusade to stop car insurance carriers from charging higher rates for those who 
                  didn't go to college or don't have a high paying job.
                </Text>
                <Col lg={{ span: 0 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 0 }} xs={{ span: 24 }}>
                  <Text>www.unjustcarinsurance.com</Text>
                </Col>
              </Col>
            </Link>
          </div>
          <Text className={`${WhyCureStyle["why-cure-subtitle"]}`}>How CURE came to be</Text>
          <Text className={`${WhyCureStyle["why-cure-text"]}`}>
            During the 1980s, car insurers were reluctant to write car insurance in New Jersey due to low profitability 
            and significant legislative constraints. In response to this crisis, Citizens United Reciprocal Exchange (CURE) 
            was founded as a solution to the ailing car insurance industry.
          </Text>
          <Text className={`${WhyCureStyle["why-cure-subtitle"]}`}>We don&apos;t discriminate</Text>
          <Text className={`${WhyCureStyle["why-cure-text"]}`}>
            CURE cares mostly about how well you drive. We refuse to adopt discriminatory income rating factors like 
            education and occupation that most other insurers use. Drive well! 
          </Text>
        </div>
        <Row>
          <Col lg={17} md={12} sm={24} xl={{ span: 17 }} xs={24} />
        </Row>
      </div>
      <div className={`${WhyCureStyle["hdivider-container"]}`}>
        <div style={{width: '950px'}}> 
          <Divider type="horizontal" className={`${WhyCureStyle["divider-custom"]}`} />
        </div>
      </div>
      <GetQuoteAndCustomerLinks />
    </>
  )
}

WhyCure.propTypes = {}

export default WhyCure
